import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import { PpraFilter, PpraResponse } from "@/types/ppra";

function params(filter: PpraFilter) {
  return {
    tgl_start: filter.tgl_start,
    tgl_end: filter.tgl_end,
    unit: filter.unit,
    aware: filter.aware,
    antibiotik: filter.antibiotik || undefined,
    hanya_penerima_antibiotik: filter.hanya_penerima_antibiotik ? 1 : 0
  };
}

function suffix(filter: PpraFilter) {
  return filter.tgl_start === filter.tgl_end
    ? filter.tgl_start
    : `${filter.tgl_start}_${filter.tgl_end}`;
}

async function preview(filter: PpraFilter): Promise<PpraResponse> {
  const res = await http
    .getDataParam(`/laporan/ppra`, { params: params(filter) })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data;
}

async function openPdf(filter: PpraFilter): Promise<void> {
  const res = await http
    .getDataParam(`/laporan/ppra/pdf`, {
      params: params(filter),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], { type: "application/pdf" })
  );
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

async function downloadExcel(filter: PpraFilter): Promise<void> {
  const res = await http
    .getDataParam(`/laporan/ppra/excel`, {
      params: params(filter),
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
  );
  const a = document.createElement("a");
  a.href = url;
  a.download = `laporan-ppra_${suffix(filter)}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default {
  preview,
  openPdf,
  downloadExcel
};
